// extracted by mini-css-extract-plugin
export default {"herosection-container":"Herosection_herosection-container__OStxC","Mobile":"Herosection_Mobile__ku+CC","Desktop":"Herosection_Desktop__P00T7"};